class EfEtiquetasSelector {
    static get $inject() {
        return ['$scope', '$element']
    }

    constructor($scope, $element) {
        this.showEtiquetasSelector = false
        this.element = $element
        this.apply = fn => $scope.$apply(fn)

        $scope.$watchCollection(() => this.etiquetas, newValue => {
            if (newValue) {
                this.ngModelCtrl.$setViewValue(newValue)
            }
        })
    }

    $onInit() {
        this.ngModelCtrl.$render = () => {
            const value = this.ngModelCtrl.$viewValue
            
            this.etiquetas = value ? value : []
        }

        this.onFocusEnter = () => {
            this.apply(() => {
                this.isFocused = true
            })
        }

        this.onFocusLeave = $event => {
            if ($event.relatedTarget && !this.element.context.contains($event.relatedTarget)) {
                this.apply(() => {
                    this.isFocused = false

                    this.showEtiquetasSelector = false
                })
            }
        }

        const selector = this.element.find('.etiquetas-selector > div')

        selector.context.addEventListener('focusin', this.onFocusEnter)
        selector.context.addEventListener('focusout', this.onFocusLeave)
    }

    $onDestroy() {
        const selector = this.element.find('.etiquetas-selector > div')

        selector.context.removeEventListener('focusin', this.onFocusEnter)
        selector.context.removeEventListener('focusout', this.onFocusLeave)
    }

    onEtiquetasSelectClose($event) {
        const selector = this.element.context.querySelector('.etiquetas-selector > div')

        this.showEtiquetasSelector = selector == $event.target || selector.contains($event.target)

        this.isFocused = this.showEtiquetasSelector
    }

    onKeyDown($event) {
        const selector = this.element.context.querySelector('.etiquetas-selector > div')

        if (['Enter', ' '].includes($event.key) && $event.target === selector) {
            this.showEtiquetasSelector = true
            $event.preventDefault()
        }
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('efEtiquetasSelector', {
        controller: EfEtiquetasSelector,
        bindings: {
            empresaId: '<',
            position: '@'
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <div class="etiquetas-selector" >
                <div 
                    tabindex="0"
                    ng-class="{'is-focused': $ctrl.isFocused}"
                    ng-click="$ctrl.showEtiquetasSelector = !$ctrl.showEtiquetasSelector"
                    ng-keydown="$ctrl.onKeyDown($event)">
                    <div class="etiquetas">
                        <ef-etiqueta 
                            ng-repeat="etiqueta in $ctrl.etiquetas"
                            nome="{{etiqueta.nome}}"
                            descricao="{{etiqueta.descricao}}"
                            cor="{{etiqueta.cor}}">
                        </ef-etiqueta>
                    </div>
                    <i class="fa fa-caret-down"></i>
                </div>
                <ef-etiquetas-popover 
                    ng-if="$ctrl.showEtiquetasSelector" 
                    ng-model="$ctrl.etiquetas" 
                    empresa-id="$ctrl.empresaId" 
                    on-close="$ctrl.onEtiquetasSelectClose($event)"
                    position="{{$ctrl.position}}">
                </ef-etiquetas-popover>
            </div>
        `
    })
